








import Vue from "vue";
import { DecisionComment } from "@megarax/client/src/resources/Decision";
export default Vue.extend({
  name: "DecisionCommentView",
  props: {
    value: {
      type: DecisionComment,
      required: true,
    },
  },
  filters: {
    formatDate: (date?: Date) => (date ? date.toLocaleString() : "-"),
  },
});
